/**
 * Switch Renderer
 * Features: toggle switch with label and optional description
 * Layout: Label and description on left, switch on right
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import type { FieldRenderer } from '@/MyCode/core';

export const renderSwitch: FieldRenderer = ({
    field,
    value,
    handleChange,
    isRequired
}) => (
    <div className="flex items-center justify-between">
        <div className="space-y-0.5">
            <Label htmlFor={field.name}>
                {field.label}
                {isRequired && <span className="text-destructive ml-1">*</span>}
            </Label>
            {field.placeholder && (
                <p className="text-sm text-muted-foreground">
                    {field.placeholder}
                </p>
            )}
        </div>
        <Switch
            id={field.name}
            checked={value || false}
            onCheckedChange={(checked) => handleChange(field.name, checked)}
        />
    </div>
);

export default renderSwitch;
